import type { BoxProps } from '@mui/material';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const ContentBox = styled(Box)<BoxProps>(({ theme }) => ({
  // Being explicit with margin left/right just so I'm sure I don't override top/bottom.
  marginLeft: 'auto',

  marginRight: 'auto',
  maxWidth: '1040px',

  [theme.breakpoints.only('xs')]: {
    marginLeft: '16px',
    marginRight: '16px',
  },
  [theme.breakpoints.only('sm')]: {
    marginLeft: '32px',
    marginRight: '32px',
  },
  [theme.breakpoints.only('md')]: {
    width: '840px',
  },
  [theme.breakpoints.only('lg')]: {
    marginLeft: '200px',
    marginRight: '200px',
  },
}));

export { ContentBox, ContentBox as default };
